import { render, staticRenderFns } from "./CptuModelerDetailsModal.vue?vue&type=template&id=3af404b8"
import script from "./CptuModelerDetailsModal.vue?vue&type=script&lang=js"
export * from "./CptuModelerDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports